(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["vc-launch-messages"] && !Shopify.designMode) return;
  try {
    let vitalCoreLaunchRefreshTimer;

  function updateVitalCoreLaunchEstimates() {
    window.clearTimeout(vitalCoreLaunchRefreshTimer);
    const messages = document.querySelectorAll('[data-vc-launch-estimate]');
    if (!messages.length) return;
    const now = new Date();
    const estimate = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 4, 12);
    const label = new Intl.DateTimeFormat('en-US', {
      weekday: 'long',
      month: 'long',
      day: 'numeric'
    }).format(estimate);
    const dateTime = [
      estimate.getFullYear(),
      String(estimate.getMonth() + 1).padStart(2, '0'),
      String(estimate.getDate()).padStart(2, '0')
    ].join('-');

    messages.forEach((message) => {
      const date = message.querySelector('[data-vc-launch-date]');
      if (!date) return;
      date.textContent = label;
      date.dateTime = dateTime;
      message.hidden = false;
    });

    const nextRefresh = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 1);
    vitalCoreLaunchRefreshTimer = window.setTimeout(updateVitalCoreLaunchEstimates, nextRefresh.getTime() - now.getTime());
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', updateVitalCoreLaunchEstimates, { once: true });
  } else {
    updateVitalCoreLaunchEstimates();
  }

  document.addEventListener('shopify:section:load', updateVitalCoreLaunchEstimates);
  window.addEventListener('pageshow', updateVitalCoreLaunchEstimates);
  document.addEventListener('visibilitychange', () => {
    if (document.visibilityState === 'visible') updateVitalCoreLaunchEstimates();
  });

  function bindVitalCoreVariantControls() {
    document.querySelectorAll('[data-vc-variant-controls]').forEach((marker) => {
      const form = marker.closest('form');
      if (!form || marker.dataset.vcBound === 'true') return;
      marker.dataset.vcBound = 'true';
      const buttons = Array.from(document.querySelectorAll('[data-buy]')).filter((button) => button.form === form);
      const sync = () => {
        const selected = form.querySelector('input[name="id"]:checked, input[type="hidden"][name="id"]');
        const available = !!selected && !selected.disabled && (selected.type === 'radio' || marker.dataset.vcInitialAvailable === 'true');
        buttons.forEach((button) => {
          button.disabled = !available;
          button.textContent = available ? marker.dataset.vcBuyLabel : marker.dataset.vcSoldOutLabel;
        });
        return available;
      };
      form.addEventListener('change', (event) => {
        if (event.target.name === 'id') sync();
      });
      form.addEventListener('submit', (event) => {
        if (!sync()) {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }, true);
      window.addEventListener('pageshow', sync);
      sync();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindVitalCoreVariantControls, { once: true });
  } else {
    bindVitalCoreVariantControls();
  }
  document.addEventListener('shopify:section:load', bindVitalCoreVariantControls);
  } catch(e) { console.error(e); }
})();

})();
